import { Button } from 'base/ui/button';
import { Dialog, DialogHeroImage } from 'base/ui/dialog';
import { TextRegularLight } from 'base/ui/typography';
import React from 'react';
import exportWebflowSafariWarningImage from './export_webflow_safari_warning.webp';

export function WebflowSafariWarningDialog({
  onClose,
}: {
  onClose: () => void;
}) {
  return (
    <Dialog
      title="Use Chrome to paste into Webflow"
      onClose={onClose}
      buttons={
        <>
          <Button
            label="Go to Chrome"
            variant="primary"
            href="https://www.google.com/chrome/"
            target="_blank"
            size="large"
          />
        </>
      }
    >
      <DialogHeroImage
        src={exportWebflowSafariWarningImage}
        aspectRatio="864/480"
        alt=""
      />
      <TextRegularLight>
        Copying and pasting Webflow components is not supported on Safari.
        Please use a compatible browser, such as Chrome, Edge, or Firefox.
      </TextRegularLight>
    </Dialog>
  );
}
